<!-- PDF: render in iframe -->
@if (isPdf && blobUrl && !pdfFullscreen) {
	<iframe [src]="blobUrl" class="document-iframe" title="Document viewer"> </iframe>
}

<!-- PDF Fullscreen overlay -->
@if (isPdf && pdfFullscreen) {
	<div class="pdf-fullscreen-overlay" data-testid="document-viewer-panel-pdf-fullscreen">
		<div class="docx-fullscreen-bar">
			<button class="docx-back-btn" (click)="pdfFullscreen = false" aria-label="Back" data-testid="document-viewer-btn-exit-pdf-fullscreen"><mat-icon>arrow_back</mat-icon></button>
			<span class="docx-fullscreen-title">{{ title }}</span>
		</div>
		<iframe [src]="blobUrl" class="pdf-fullscreen-iframe" title="Document viewer"></iframe>
	</div>
}

<!-- DOCX: render with docx-preview -->
@if (isDocx) {
	<div class="docx-container" [class.fullscreen-docx]="docxFullscreen">
		@if (docxFullscreen) {
			<div class="docx-fullscreen-bar">
				<button class="docx-back-btn" (click)="docxFullscreen = false" aria-label="Back" data-testid="document-viewer-btn-exit-docx-fullscreen"><mat-icon>arrow_back</mat-icon></button>
				<span class="docx-fullscreen-title">{{ title }}</span>
				<span class="docx-disclaimer-inline"
					>Preview may differ from original. <a class="docx-download-link" (click)="onDownload()" data-testid="document-viewer-link-download">Download the actual file</a>.</span
				>
			</div>
		}
		<div class="docx-scroll-area" #docxContainer></div>
	</div>
}

<!-- Text/Markdown: render with markdown renderer -->
@if (isText && documentText) {
	<markdown [data]="documentText"></markdown>
}

<!-- Other types: show download prompt -->
@if (!isPdf && !isDocx && !isText) {
	<div class="document-download-prompt" data-testid="document-viewer-panel-download-prompt">
		<mat-icon class="download-prompt-icon">description</mat-icon>
		<p>This document type cannot be previewed in the browser.</p>
		<button class="download-btn" (click)="onDownload()" data-testid="document-viewer-btn-download">
			<mat-icon>download</mat-icon>
			Download Document
		</button>
	</div>
}
